<div class="page">
  <kgrid
    #grid
    [areaName]="areaName"
    [label]="label"
    pathPreFix="SALE"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [columns]="columns"
    [apiName]="'SaleFormula/GoodsList'"
    [isAdd]="true"
    [isEdit]="true"
    [isDelete]="true"
    [useCustomDelete]="true"
    (onDelete)="deleteGoods($event)">
  </kgrid>
</div>
